import { memo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import FilterIcon from '../../../../assets/icons/filter.svg?react';
import { useReactiveProperty } from '../../../Properties/reactive/useReactiveProperty';
import { PropertyType } from '../../../Properties/types';

interface WallSketchFilterToggleProps {
  /** The wall sketch's FLOOR group id — heatmap/clipping settings were
   *  consolidated onto the floor (`floor_heatmap_*` + source dropdown), so
   *  the toggle drives the floor-level clip property. */
  floorGroupId: string;
}

const WallSketchFilterToggle_: React.FC<WallSketchFilterToggleProps> = ({ floorGroupId }) => {
  const { projectId = '' } = useParams();

  const [isFilterEnabled, setFilterEnabled] = useReactiveProperty({
    projectId,
    identifier: 'floor_heatmap_clip_enabled',
    objectIdentifier: floorGroupId,
    propertyType: PropertyType.PROJECT_GLOBAL,
  });

  const onToggleFilter = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      setFilterEnabled(!isFilterEnabled);
    },
    [isFilterEnabled, setFilterEnabled],
  );

  return (
    <div onClick={onToggleFilter} className={`flex items-center justify-center w-6 h-6 cursor-pointer ${isFilterEnabled ? 'text-black dark:text-neon-green-300' : 'text-[#6F7173] hover:text-black dark:hover:text-neon-green-300'}`}>
      <FilterIcon className="w-4 h-4" />
    </div>
  );
};

export const WallSketchFilterToggle = memo(WallSketchFilterToggle_);
